export default __webpack_public_path__ + "static/media/ISicily_english_reduced.98bb9d6f.jpg";